var _circle, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle3, _polygon, _polygon2, _polygon3, _polygon4, _rect9, _polygon5, _rect10, _polygon6, _rect11, _polygon7, _rect12, _polygon8, _rect13, _polygon9, _rect14, _rect15, _ellipse, _ellipse2, _ellipse3, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroAboriginal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "78 56 380 282",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Three Indigenous people at work outdoors, by mountains, trees and a lake, with a job offer card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 200,
    r: 160,
    fill: "#fef9c3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 96,
    r: 34,
    fill: "#fef3c7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 66,
    width: 4,
    height: 10,
    rx: 2,
    fill: "#eab308",
    transform: "rotate(0 380 96)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 66,
    width: 4,
    height: 10,
    rx: 2,
    fill: "#eab308",
    transform: "rotate(45 380 96)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 66,
    width: 4,
    height: 10,
    rx: 2,
    fill: "#eab308",
    transform: "rotate(90 380 96)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 66,
    width: 4,
    height: 10,
    rx: 2,
    fill: "#eab308",
    transform: "rotate(135 380 96)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 66,
    width: 4,
    height: 10,
    rx: 2,
    fill: "#eab308",
    transform: "rotate(180 380 96)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 66,
    width: 4,
    height: 10,
    rx: 2,
    fill: "#eab308",
    transform: "rotate(225 380 96)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 66,
    width: 4,
    height: 10,
    rx: 2,
    fill: "#eab308",
    transform: "rotate(270 380 96)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 66,
    width: 4,
    height: 10,
    rx: 2,
    fill: "#eab308",
    transform: "rotate(315 380 96)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 96,
    r: 14,
    fill: "#eab308"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "90,318 170,170 250,318",
    fill: "#a7f3d0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "200,318 290,140 380,318",
    fill: "#6ee7b7"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "290,140 270,180 282,176 290,188 298,176 310,180",
    fill: "#ffffff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "310,318 380,200 450,318",
    fill: "#a7f3d0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 296,
    width: 360,
    height: 22,
    rx: 6,
    fill: "#bae6fd"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "112,236 126,274 98,274",
    fill: "#15803d"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 274,
    width: 4,
    height: 8,
    fill: "#78350f"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "130,222 144,260 116,260",
    fill: "#15803d"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 260,
    width: 4,
    height: 8,
    fill: "#78350f"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "370,230 384,268 356,268",
    fill: "#15803d"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 268,
    width: 4,
    height: 8,
    fill: "#78350f"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "392,244 406,282 378,282",
    fill: "#15803d"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 282,
    width: 4,
    height: 8,
    fill: "#78350f"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "410,228 424,266 396,266",
    fill: "#15803d"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 266,
    width: 4,
    height: 8,
    fill: "#78350f"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 318,
    width: 360,
    height: 8,
    rx: 4,
    fill: "#facc15"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140,
    cy: 320,
    rx: 32,
    ry: 4,
    fill: "#a16207",
    opacity: 0.18
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 236,
    cy: 320,
    rx: 32,
    ry: 4,
    fill: "#a16207",
    opacity: 0.18
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 320,
    cy: 320,
    rx: 32,
    ry: 4,
    fill: "#a16207",
    opacity: 0.18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 246,
    width: 13,
    height: 68,
    rx: 6,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 246,
    width: 13,
    height: 68,
    rx: 6,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 318 q0 -9 9 -9 h3 v9 z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 318 q0 -9 -9 -9 h-3 v9 z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 184,
    width: 42,
    height: 68,
    rx: 15,
    fill: "#dc2626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 168,
    width: 12,
    height: 20,
    rx: 5,
    fill: "#9e6c4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 186 q9 7 18 0",
    fill: "none",
    stroke: "#b01e1e",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 194 Q121.0 218.0 123 242",
    fill: "none",
    stroke: "#dc2626",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123,
    cy: 242,
    r: 5.5,
    fill: "#b47b55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 194 Q180.5 204.0 180 214",
    fill: "none",
    stroke: "#dc2626",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 214,
    r: 5.5,
    fill: "#b47b55"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 152,
    r: 18,
    fill: "#b47b55"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 153,
    r: 3.5,
    fill: "#b47b55"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 153,
    r: 3.5,
    fill: "#b47b55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 154 q-1 -25 19 -25 q20 0 19 25 q-4 -12 -19 -13 q-15 1 -19 13 z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 150,
    width: 8,
    height: 62,
    rx: 4,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.5,
    y: 204,
    width: 9,
    height: 4,
    rx: 2,
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 150,
    width: 8,
    height: 62,
    rx: 4,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.5,
    y: 204,
    width: 9,
    height: 4,
    rx: 2,
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 161 q5 4.5 10 0",
    fill: "none",
    stroke: "#1f2937",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(8 184 215)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 200,
    width: 24,
    height: 30,
    rx: 3,
    fill: "#ffffff",
    stroke: "#ca8a04",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 207,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#ca8a04",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 214,
    width: 10,
    height: 3,
    rx: 1.5,
    fill: "#d1d5db"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 246,
    width: 13,
    height: 68,
    rx: 6,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 246,
    width: 13,
    height: 68,
    rx: 6,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 318 q0 -9 9 -9 h3 v9 z",
    fill: "#78350f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 318 q0 -9 -9 -9 h-3 v9 z",
    fill: "#78350f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 184,
    width: 42,
    height: 68,
    rx: 15,
    fill: "#f97316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215 192 q4 -6 11 -6 v62 h-11 z",
    fill: "#a3e635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 192 q-4 -6 -11 -6 v62 h11 z",
    fill: "#a3e635"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 222,
    width: 11,
    height: 4,
    fill: "#e5e7eb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 222,
    width: 11,
    height: 4,
    fill: "#e5e7eb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 168,
    width: 12,
    height: 20,
    rx: 5,
    fill: "#936241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 186 q9 7 18 0",
    fill: "none",
    stroke: "#c75c11",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 194 Q206.5 218.0 208 242",
    fill: "none",
    stroke: "#f97316",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208,
    cy: 242,
    r: 5.5,
    fill: "#a8704a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 194 Q265.5 218.0 264 242",
    fill: "none",
    stroke: "#f97316",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 242,
    r: 5.5,
    fill: "#a8704a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 152,
    r: 18,
    fill: "#a8704a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 153,
    r: 3.5,
    fill: "#a8704a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 153,
    r: 3.5,
    fill: "#a8704a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 150 q-1 -21 18 -21 q19 0 18 21 q-6 -9 -18 -10 q-12 1 -18 10 z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 143 q0 -20 19 -20 q19 0 19 20 z",
    fill: "#facc15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 141,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#eab308"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 124,
    width: 6,
    height: 18,
    rx: 3,
    fill: "#eab308"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 161 q5 4.5 10 0",
    fill: "none",
    stroke: "#1f2937",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 307,
    y: 262,
    width: 9,
    height: 52,
    rx: 4.5,
    fill: "#c48b62"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 262,
    width: 9,
    height: 52,
    rx: 4.5,
    fill: "#c48b62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 318 q0 -9 9 -9 h3 v9 z",
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 318 q0 -9 -9 -9 h-3 v9 z",
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 236 h32 l8 32 h-48 z",
    fill: "#e5e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 152 q0 -28 21 -28 q21 0 21 28 v18 q-21 6 -42 0 z",
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 184,
    width: 42,
    height: 68,
    rx: 15,
    fill: "#0d9488"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 168,
    width: 12,
    height: 20,
    rx: 5,
    fill: "#ac7a56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 186 q9 7 18 0",
    fill: "none",
    stroke: "#0a766c",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 194 Q289.0 216.0 291 238",
    fill: "none",
    stroke: "#0d9488",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 238,
    r: 5.5,
    fill: "#c48b62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 194 Q348.5 210.0 348 226",
    fill: "none",
    stroke: "#0d9488",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348,
    cy: 226,
    r: 5.5,
    fill: "#c48b62"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 152,
    r: 18,
    fill: "#c48b62"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 153,
    r: 3.5,
    fill: "#c48b62"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336,
    cy: 153,
    r: 3.5,
    fill: "#c48b62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 154 q-1 -25 19 -25 q20 0 19 25 q-4 -12 -19 -13 q-15 1 -19 13 z",
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 161 q5 4.5 10 0",
    fill: "none",
    stroke: "#1f2937",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332,
    y: 212,
    width: 32,
    height: 20,
    rx: 3,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 215,
    width: 26,
    height: 14,
    rx: 1.5,
    fill: "#93c5fd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 232,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#475569"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(358 250) rotate(4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 54,
    rx: 11,
    fill: "#ffffff",
    stroke: "#fde68a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 10,
    fill: "#eab308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19 l3.5 3.5 l7 -7.5",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 12,
    width: 50,
    height: 6,
    rx: 3,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 23,
    width: 34,
    height: 5,
    rx: 2.5,
    fill: "#d1d5db"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 38,
    width: 73,
    height: 7,
    rx: 3.5,
    fill: "#fef9c3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 38,
    width: 46,
    height: 7,
    rx: 3.5,
    fill: "#eab308"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#f59e0b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92 112 l4 9 l9 4 l-9 4 l-4 9 l-4 -9 l-9 -4 l9 -4 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 172 l3 6 l6 3 l-6 3 l-3 6 l-3 -6 l-6 -3 l6 -3 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroAboriginal);
export default __webpack_public_path__ + "static/media/hero-aboriginal.ffd3d2eb25e9f68e27987defed7552af.svg";
export { ForwardRef as ReactComponent };